import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const MonthlyDaysRoute: ViewRoute = {
  [RouteNames.monthlydays]: () => {
    return RouteNames.averageDay;
  }
};
